import React, { useEffect, useState, useMemo, useRef } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { Container } from '@material-ui/core';
import Breadcrumbs from 'components_newui/pageBreadcrumbsMenu/View';
import Navigation from 'support/navigation'
import styles from './View.Style';
import Loading from 'components_newui/Loading';
import { fixAndParseJSON, safeParseJSON } from 'services/RequestUtils';
// import ErrorBoundaryWrapper from './ErrorBoundaryWrapper';
// Subcomponents
import IdeaHeader from './subcomponents/IdeaHeader';
import IdeaCarousel from './subcomponents/IdeaCarousel';
import IdeaSummaryCard from './subcomponents/IdeaSummaryCard';
import IdeaContent from './subcomponents/IdeaContent';
import EvaluatorSection from './subcomponents/EvaluatorSection';
import Dialogs from './subcomponents/Dialogs';
import IdeaHistory from './subcomponents/IdeaHistory';
import i18n from 'support/i18n'

const InnovateIdeaDetails = (props) => {
  // console.log("🚀 ~ InnovateIdeaDetails [][][]][]][]][][] props:", props)
  const {
    csrf,
    isInnovator,
    match,
    classes,
    getInnovateIdeaTemplateIdJsonFn,
    isLoadingGetIdeaDetail,
    getIdeaDetailsResponse,
    getIdeaDetailFn,
    getListEvaluatorAssignedForIdeaFn,
    getInnovateChallengeActiveTypesFn,
    handleEditIdeaInnovateFn,
    handleOnDeleteClick,
    handlePostInnovateIdeaAddEvaluator,
    deleteAssignedEvaluatorIntoIdeaFn,
    getJsonRatedEvaluatorScorecardFn,
    isAdmin,
    isEvaluator,
    userEmail: loginUserEmail,
    getListEvaluatorAssignedIdea,
    deleteAssignedEvaluatorIdeaIsLoading,
    getJsonEvaluatorForRatingIsLoading,
    innovateCategoryTypes,
    evaluationLoading,
    userEvaluatorSuggestions,
    getSearchByCommunityUserInnovateIdeaSuggestions,
    onUserEvaluatorSearchSuggestions,
    postInnovateIdeaEvaluatorRatingSaveFn,
    putInnovateIdeaEvaluatorRatingEditFn,
    putInnovateIdeaEvaluatorRatingSubmitFn,
    getInnovateIdeaTemplateIdJson,
    getJsonChallengeTemplateId,
    getScorecardJsonBasedOnChallengeTemplateIdFn,
    getJsonEvaluatorForRating,
    postInnovateIdeaApproveFn,
    postApproveIdeaIsLoading,
    getUserValidateEvaluatorScorecardRoleFn,
    innovateUserIsEvaluatorOrNot,
    getInnovateIdeaTeamFn,
    getInnovateIdeaTeamData,
    getInnovateIdeaTeamIsLoading,
    navigateToUserProfile,
    postAddInnovateIdeaTeamMembarFn,
    postInviteInnovateIdeaTeamMembarFn,
    isIdeaOwner,
    postInnovateIdeaScorecardSaveRatingIsLoading,
    getShowPopupForEvaluatorScorecardAssignedIdeaFn,
    innovateShowPopupEvaluatorAssignedData,
    getScorecardTemplatelistFn,
    listScorecardTemplateLoading,
    listScorecardTemplate,
    putAddBusinessScoreCardFn,
    innovateAddBusinessScoreCardIsLoading,
    onUserEvaluatorSearchByCommunitySuggestions,
    handlePostInnovateIdeaAddSearchByCommunityEvaluator,
    listCommunitesChallenge,
    getCommunitesAsGroup,
    innovateShowPopupEvaluatorAssignedDataIsLoading,
    isHackathonEnable,
    getChallengeById,
    innovateChallengeTagIdeaCount,

    onTeamUserRemoveClick,
    canSendIdeaTeamInvitations,
    suggestions,
    pendingInvitationsUsers,
    isAlreadyInvited,
    onRequestJoinIdeaTeam,
    onPendingUserRemoveClick,
    onSearchSuggestions,
    onSendInvitationClick,
    isSearchingForUser,
    getIdeaHistoryFn,
    ideaHistoryData,
    ideaHistoryIsLoading,
    moveToDraftFn,
    moveToDraftIsLoading,
    navigateToScorecardNewTabFn,
  } = props || {};

  const getIdeaIdFromURL = match.params.id;
  

  const [checkEnableEvaluatorRatingButton, setCheckEnableEvaluatorRatingButton] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpenApprove, setDialogOpenApprove] = useState(false);
  const [dialogEvaluatorRateOpen, setDialogEvaluatorRateOpen] = useState(false);
  const [dialogEvaluatorOpen, setDialogEvaluatorOpen] = useState(false);
  const [childValueSelectedUserTags, setChildValueSelectedUserTags] = useState('');
  const [dialogEvaluatorShowAllOpen, setDialogEvaluatorShowAllOpen] = useState(false);
  const [dialogScoreCardShowAllOpen, setDialogScoreCardShowAllOpen] = useState(false);
  const [dialogBusinessScoreCardShowAllOpen, setDialogBusinessScoreCardShowAllOpen] = useState(false);
  const [dialogBusinessEvaluatorShowAllOpen, setDialogBusinessEvaluatorShowAllOpen] = useState(false);

  const [dialogOpenForTeamSearchAdd, setDialogOpenForTeamSearchAdd] = useState(false);
  const [dialogHistoryOpen, setDialogHistoryOpen] = useState(false);
  const [selectedEvaluator, setSelectedEvaluator] = useState({});
  const [communityValueChange, setCommunityValueChange] = useState('');
  const [childValue_Assign_Evaluator_Selected_SCData, setChildValue_Assign_Evaluator_Selected_SCData] = useState('');
  const [dialogOpenBusinessScorecard, setDialogOpenBusinessScorecard] = useState(false);

  const handleEvaluatorClick = (evaluator) => {
    // console.log("evaluatorevaluatorevaluatorevaluatorevaluator ====> :", evaluator)
    setSelectedEvaluator(evaluator);
    setDialogEvaluatorOpen(true);
  };

  useEffect(() => {
    getIdeaDetailFn?.(getIdeaIdFromURL);
    getInnovateChallengeActiveTypesFn?.();
    getListEvaluatorAssignedForIdeaFn?.(getIdeaIdFromURL);
    getCommunitesAsGroup?.()
  }, [getIdeaIdFromURL]);

  useEffect(() => {
    if (getIdeaIdFromURL) {
      getInnovateIdeaTeamFn(getIdeaIdFromURL)
    }
  }, [getIdeaIdFromURL])


  useEffect(() => {
    setCheckEnableEvaluatorRatingButton(innovateUserIsEvaluatorOrNot)
  }, [innovateUserIsEvaluatorOrNot])

  useEffect(() => {
    getScorecardTemplatelistFn()
  }, [])

  const prevMoveToDraftLoading = useRef(false);
  useEffect(() => {
    if (prevMoveToDraftLoading.current && !moveToDraftIsLoading) {
      // Refresh idea detail after successful move to draft
      getIdeaDetailFn?.(getIdeaIdFromURL);
    }
    prevMoveToDraftLoading.current = moveToDraftIsLoading;
  }, [moveToDraftIsLoading])

  const idea = getIdeaDetailsResponse?.ideaForInnovater || {};

  const ideaTemplateId = idea?.challenge?.ideaTemplateId
  const ideaChallengeId = idea?.challenge?.id
  // const ideaTemplateId = 5260063627280384

  //  Remove items where userEmail does NOT match loginUserEmail  
  const filteredDataGetListEvaluatorAssignedIdea = getListEvaluatorAssignedIdea.filter(item => item.userEmail === loginUserEmail);
  const ChallengeTemplateId = idea?.challenge?.challengeTemplateId // this template used for double scorecard
  //!!!!!!!!!!!!!!!!!!!!!! important flag to maintain isHackthon scorecard and innovate south africa scorecard
  const check_IsHackathonChallenge = idea?.challenge?.isHackathonChallenge
  const isHackathonChallengeFlag = check_IsHackathonChallenge ?? false;
  // console.log("======check_IsHackathonChallenge=====> : ", check_IsHackathonChallenge)

  useEffect(() => {
    if (ideaTemplateId) {
      getInnovateIdeaTemplateIdJsonFn(ideaTemplateId)
    }
  }, [ideaTemplateId])

  useEffect(() => {
    if (ideaChallengeId) {
      getChallengeById(ideaChallengeId)
    }
  }, [ideaChallengeId])

  // const objUserAndIdeaIDOld = {
  //   ideaIdKey:getIdeaIdFromURL,
  //   userEmail:loginUserEmail
  // }

  // // console.log("🚀 ~ InnovateIdeaDetails ~ objUserAndIdeaID:", objUserAndIdeaID)

  // useEffect(() => {
  //   if(getIdeaIdFromURL){
  //     getUserValidateEvaluatorScorecardRoleFn(objUserAndIdeaIDOld)
  //   }
  // }, [loginUserEmail,getIdeaIdFromURL,innovateUserIsEvaluatorOrNot])



  const { ownerPhoto, challengeOrganizerEmailList, teamUsers , owner, challenge, id: ideaId, visits, approvedText, title, status, textWithoutTags, published, created, ownerName, businessUnit, market, images, ideaTemplateAnswers, ideaTemplate, additionalInfo, businessScoreCardTemplateId } = idea;
  const { challengeTemplateId, categoryTypeId, status:ChallengeStatus , ends:challengeEndDate} = challenge || {};
  const isOwnerRole = owner === loginUserEmail
  // console.log("🚀 ~ I?nnovateIdeaDetails ~ isOwnerCheck: innovateUserIsEvaluatorOrNot", isOwnerRole , innovateUserIsEvaluatorOrNot)
  const selectedType = innovateCategoryTypes.find(type => +type.id === +categoryTypeId);

  const rawJsonString = ideaTemplate?.value
  const AnswerRawJsonString = ideaTemplateAnswers?.value
  // const dataQuestArray = safeParseJSON(rawJsonString || []);
  //  const dataQuestArray = rawJsonString || []
  //  console.log(typeof dataQuestArray,   ); 
  // console.log("🚀 ~ InnovateIdeaDetails ~ dataQuestArray:", dataQuestArray)
  // const dataAnsArray = safeParseJSON(AnswerRawJsonString || []);
  // const dataAnsArray = fixAndParseJSON(AnswerRawJsonString || []);
  // const dataAnsArray = AnswerRawJsonString || [];
  // console.log("🚀 ~ InnovateIdeaDetails ~ dataAnsArray:", dataQuestArray, 'answer', dataAnsArray,AnswerRawJsonString , typeof AnswerRawJsonString)
  // const  challengeTemplateId = 5752644836524032

  // console.log("before render json data: answer", AnswerRawJsonString, dataAnsArray, typeof dataAnsArray, typeof AnswerRawJsonString)


  let dataAnsArray = null;
  let err = null;

  try {
    dataAnsArray = JSON.parse(AnswerRawJsonString);
  } catch (e) {
    err = e;
    console.error('JSON parse error:', err);
  }


  // const isHackathonChallengeFlag = false
  // need to figureour out why this called api ***
  useEffect(() => {
    if (challengeTemplateId) {
      getScorecardJsonBasedOnChallengeTemplateIdFn(challengeTemplateId)
    }
  }, [challengeTemplateId])


  // set for doublescrore card dropdown data on assign evaluator
  const ArrayOfObjDoubleScorecard = listScorecardTemplate?.filter(template =>
    template.id === ChallengeTemplateId || template.id === Number(businessScoreCardTemplateId)
  );

  // 1) Derive the correct flag for the logged-in evaluator and current idea
  const businessSCFlag = useMemo(() => {
    // Guard array presence
    if (!Array.isArray(filteredDataGetListEvaluatorAssignedIdea)) return "";

    // Find matching record by both ideaIdKey and userEmail (safer than index 0)
    const matchUser = filteredDataGetListEvaluatorAssignedIdea.find(
      (x) =>
        x?.ideaIdKey === getIdeaIdFromURL &&
        x?.userEmail?.toLowerCase?.() === loginUserEmail?.toLowerCase?.()
    );
    // Return flag if present, else empty string
    return matchUser?.businessScoreCardFlag ?? "";
  }, [filteredDataGetListEvaluatorAssignedIdea, getIdeaIdFromURL, loginUserEmail]);

  // console.log("businessSCFlag==< validate", businessSCFlag)
  // 2) Make a stable payload object that includes the derived flag
  const objUserAndIdeaID = useMemo(() => {
    return {
      ideaIdKey: getIdeaIdFromURL,
      userEmail: loginUserEmail,
      businessSCFlag, // <-- guaranteed to be resolved by memo above
    };
  }, [getIdeaIdFromURL, loginUserEmail, businessSCFlag]);


  // 3) Call only when all inputs are ready (prevents firing with empty flag)
  useEffect(() => {
    if (getIdeaIdFromURL && loginUserEmail && businessSCFlag) {
      getUserValidateEvaluatorScorecardRoleFn(objUserAndIdeaID);
    }
  }, [getIdeaIdFromURL, loginUserEmail, businessSCFlag]);

  // 3) Call only when all inputs are ready (prevents firing with empty flag)

  // //show open popup data when click button
  // useEffect(() => {
  //   if (getIdeaIdFromURL && loginUserEmail && businessSCFlag) {
  //     getShowPopupForEvaluatorScorecardAssignedIdeaFn(objUserAndIdeaID);
  //   }
  // }, [getIdeaIdFromURL, loginUserEmail, businessSCFlag]);


  // console.log("childValueSelectedUserTags check===>", childValueSelectedUserTags, communityValueChange)
  const scorecardTemplateJsonGetFromSourceTemplateID = getJsonChallengeTemplateId?.scoreCardJson?.value
  const setFlagBasedOnIsHackthonChallenge = isHackathonChallengeFlag ? 'E' : childValue_Assign_Evaluator_Selected_SCData?.businessSCFlag || 'B'
  const setQuestionBasedOnIsHackthonChallenge = isHackathonChallengeFlag ? scorecardTemplateJsonGetFromSourceTemplateID : childValue_Assign_Evaluator_Selected_SCData?.QuestionJson || scorecardTemplateJsonGetFromSourceTemplateID
  const setScorecardIDBasedOnIsHackthonChallenge = isHackathonChallengeFlag ? challengeTemplateId : childValue_Assign_Evaluator_Selected_SCData?.SelectedScID || challengeTemplateId

  const addEvaluatorParamsObj = {
    ideaIdKey: ideaId,
    challengeKey: challenge?.id,
    userEmail: childValueSelectedUserTags,
    scoreCardJson: setQuestionBasedOnIsHackthonChallenge, // set param questionjson based on assign evaluator selected 
    businessSCFlag: setFlagBasedOnIsHackthonChallenge,
    selectedScoreCardTemplateId: setScorecardIDBasedOnIsHackthonChallenge
    // selectedScoreCardTemplateId: childValue_Assign_Evaluator_Selected_SCData?.SelectedScID  || challengeTemplateId || null
  };

  const addCommunitySearchEvaluatorParamsObj = {
    ideaIdKey: ideaId,
    challengeKey: challenge?.id,
    userEmail: childValueSelectedUserTags,
    scoreCardJson: setQuestionBasedOnIsHackthonChallenge, // set param questionjson based on assign evaluator selected 
    businessSCFlag: setFlagBasedOnIsHackthonChallenge,
    selectedScoreCardTemplateId: setScorecardIDBasedOnIsHackthonChallenge,
    groupName: communityValueChange?.label || '',
    groupId: communityValueChange?.value || null
  };

  const handleAddBusinessScorecard = () => {
    setDialogOpenBusinessScorecard(true);
  }

  //  this handle used to assign evaluator 
  const handleConfirm = () => {
    handlePostInnovateIdeaAddEvaluator(addEvaluatorParamsObj);
    setDialogOpen(false);
  };
  const handleCommunitySearchConfirm = () => {
    handlePostInnovateIdeaAddSearchByCommunityEvaluator(addCommunitySearchEvaluatorParamsObj);
    setDialogOpen(false);
  };

  const handleRemoveEvaluator = (item) => {
    // console.log("delete item===>", item)
    const { userEmail, ideaIdKey, businessScoreCardFlag } = item || {};
    deleteAssignedEvaluatorIntoIdeaFn({ ideaIdKey: ideaIdKey || getIdeaIdFromURL, userEmail, businessSCFlag: businessScoreCardFlag });
  };

  //working ###
  // const handleOpenScorecard = () => {
  //   setDialogEvaluatorRateOpen(true);
  //   // if isHackthonChallenge is true than SET E flag if false than set B
  //   getJsonRatedEvaluatorScorecardFn({ ideaIdKey: getIdeaIdFromURL, userEmail: loginUserEmail, businessSCFlag: 'E' });
  // };


const handleOpenScorecard = () => {
  // Determine flag dynamically based on challenge status
  const flag = isHackathonChallengeFlag ? 'E' : 'B';

  // Execute your existing JSON payload fetching function
  // getJsonRatedEvaluatorScorecardFn({ 
  //   ideaIdKey: getIdeaIdFromURL, 
  //   userEmail: loginUserEmail, 
  //   businessSCFlag: flag 
  // });

  // Call the new navigation helper to handle the new tab without any popups
  navigateToScorecardNewTabFn(getIdeaIdFromURL, flag);
};



  const handleScorecardRatingJsonOpenEvaluator = (item) => {
    setDialogEvaluatorOpen(true);
    const { userEmail, ideaIdKey } = item || {};
    getJsonRatedEvaluatorScorecardFn({ ideaIdKey, userEmail });
  };

  const handleApporveFeaturePopup = () => {
    setDialogOpenApprove(!dialogOpenApprove)
  }
  const handleEvaluatorOpenPopup = () => {
    setDialogOpen(!dialogOpen)
  }

  // add team member pass Param
  const addTeamMemberParamsObj = {
    ideaIdKey: ideaId,
    userEmail: childValueSelectedUserTags,
  };

  const handleAddTeamMemberConfirm = () => {
    postAddInnovateIdeaTeamMembarFn(addTeamMemberParamsObj);
    setDialogOpenForTeamSearchAdd(false)
  }
  const onInviteTeamMemberFn = () => {
    postInviteInnovateIdeaTeamMembarFn(addTeamMemberParamsObj);
    setDialogOpenForTeamSearchAdd(false)
  }
  const handleTeamMemberOpenPopup = () => {
    setDialogOpenForTeamSearchAdd(!dialogOpenForTeamSearchAdd)
  }



// Case/whitespace-safe email compare
const norm = s => (s ?? '').trim().toLowerCase();

// Boolean: is the logged-in email assigned as an evaluator?
const isAssigned = Array.isArray(getListEvaluatorAssignedIdea)
  ? getListEvaluatorAssignedIdea.some(item => norm(item?.userEmail) === norm(loginUserEmail))
  : false;

// Final boolean: only true if all required flags are true AND the user is assigned
const isCheckForEvaluator = Boolean(
  isHackathonChallengeFlag &&
  isEvaluator &&
  innovateUserIsEvaluatorOrNot &&
  isAssigned
);


  // const checkloginEmailIsAssignedOrNot  = getListEvaluatorAssignedIdea.filter((item)=>item?.userEmail === loginUserEmail)
  // const isCheckForEvalutor = isHackathonChallengeFlag && isEvaluator ? (innovateUserIsEvaluatorOrNot && checkloginEmailIsAssignedOrNot) : null

  const handleDeleteUserFromTeamInitiative =(email) =>{
    onTeamUserRemoveClick(getIdeaIdFromURL, email, true)
  }


  const handleDeleteUserFromTeam = (email) =>{
    onPendingUserRemoveClick(getIdeaIdFromURL, email)
  }

  const handleSendInvitation = (email) => {
    onSendInvitationClick(email, getIdeaIdFromURL)
  }


  // const loggedInUserEmail = "dummy@gmail.com"; // from auth/session
  // const challengeOrganizerEmailList = ['dummy@gmail.com', 'dummy2@gmail.com'];
  

const isOrganizer = (challengeOrganizerEmailList || []).some(
  email => email.toLowerCase() === loginUserEmail?.toLowerCase()
);

  


  const pageHierarchy = [
    { string: 'Home', navigate: () => Navigation.navigateToExplore()},
    { string: 'Ideas', navigate: () => Navigation.navigateToAllIdeas()},
    { string: 'Idea details' },
  ];

  const titleCheck = idea?.title || 'Untitled';
  const imagesCheck = idea?.images || [];





  if (isLoadingGetIdeaDetail) {
    return <Loading />;
  }



  return (
    <>
      <Breadcrumbs crumbs={pageHierarchy} />
      <Container>
        <IdeaHeader
          status={status}
          challengeStatus={ChallengeStatus}
          challengeEndDate={challengeEndDate}
          approvedText={approvedText}
          onEdit={() => handleEditIdeaInnovateFn(getIdeaIdFromURL)}
          onDelete={() => handleOnDeleteClick(getIdeaIdFromURL)}
          onReject={() => { }}
          onApprove={handleApporveFeaturePopup}
          onAddEvaluator={handleEvaluatorOpenPopup}
          isHackathonChallenge={isHackathonChallengeFlag}
          isAdmin={isAdmin}
          isOrgnizer={isOrganizer}
          isOwner={isOwnerRole}
          isInnovator={isInnovator}
          isEvaluator={isEvaluator}
          isCheckForEvalutor={isCheckForEvaluator}
          evaluatorHasScorecard={filteredDataGetListEvaluatorAssignedIdea.length > 0}
          isEvaluatorAssignedToIdea={isAssigned}
          onAddBusinessScorecard={handleAddBusinessScorecard}
          onViewHistory={() => {
            getIdeaHistoryFn(getIdeaIdFromURL);
            setDialogHistoryOpen(true);
          }}
          onMoveToDraft={() => {
            moveToDraftFn(getIdeaIdFromURL);
          }}
          moveToDraftIsLoading={moveToDraftIsLoading}
        />

        <h2>{titleCheck}</h2>

        <div className={classes.grid2block}>
          <div className={classes.ideaCarousel}>
            <IdeaCarousel images={imagesCheck} />
          </div>
          <IdeaSummaryCard
            ownerPhoto={ownerPhoto}
            ownerName={ownerName}
            ownerEmail={owner}
            onUserClick={navigateToUserProfile}
            visits={visits}
            published={published || created}
            businessUnit={businessUnit}
            market={market}
            isHackathonEnable={isHackathonEnable}
            categoryName={selectedType?.name || 'N/A'}
          />
        </div>


        <div className={classes.grid8_4cols}>
          <div className={classes.grid8cols}>
            {/* <ErrorBoundaryWrapper> */}
            <IdeaContent
              challenge={challenge}
              innovateChallengeTagIdeaCount={innovateChallengeTagIdeaCount}
              additionalInfo={additionalInfo}
              documents={getIdeaDetailsResponse?.documents || []}
              description={textWithoutTags}
              formData={getInnovateIdeaTemplateIdJson}
              formAnswers={dataAnsArray}
              getIdeaTeamData={getInnovateIdeaTeamData?.team || []}
              getInnovateIdeaTeamIsLoading={getInnovateIdeaTeamIsLoading}
              onTeamUserClick={navigateToUserProfile}
              csrfToken={csrf}
              classes={classes}
              isAdmin={isAdmin}
              isOrganizer={isOrganizer}
              isOwner={isOwnerRole}
              handleTeamMemberOpenPopup={handleTeamMemberOpenPopup}
              onTeamUserRemoveClick={handleDeleteUserFromTeamInitiative}
              canSendIdeaTeamInvitations='true'
              suggestions={suggestions}
              pendingInvitationsUsers={pendingInvitationsUsers}
              idea_id={getIdeaIdFromURL}
              isAlreadyInvited={isAlreadyInvited}
              onRequestJoinIdeaTeam={onRequestJoinIdeaTeam}
              handleDeleteUserFromTeam={handleDeleteUserFromTeam}
              navigateToUserProfile={navigateToUserProfile}
              onSearchSuggestions={onSearchSuggestions}
              handleSendInvitation={handleSendInvitation}
              isSearchingForUser={isSearchingForUser}
              ownerEmail ={owner}
              title={title}
              team={getInnovateIdeaTeamData?.team || []}
              inviteTeam={getInnovateIdeaTeamData?.teamInvited || []}
              // inputHelpText={i18n.t('IDEA.INVITE_PROMOTERS')}
              inputHelpText='You can Invite a Team Member here'
              inputLabel={i18n.t('IDEA.INVITE_MEMBER_IT')}
            />
            {/* </ErrorBoundaryWrapper> */}
          </div>
          
          <div className={classes.grid4cols}>
          {(isAdmin || isEvaluator || isInnovator || isOrganizer) &&
            <EvaluatorSection
              classes={classes}
              onScorecard={handleOpenScorecard}
              isEvaluator={isEvaluator}
              isHackathonChallenge={isHackathonChallengeFlag}
              isAdmin={isAdmin}
              isInnovator={isInnovator}
              isOrganizer={isOrganizer}
              evaluators={getListEvaluatorAssignedIdea}
               isCheckForEvalutor={isCheckForEvaluator}
               isValidateStatus={status}
              isEligible={isCheckForEvaluator}
              loginUserEmail={loginUserEmail}
              onRemove={handleRemoveEvaluator}
              onViewScorecard={handleScorecardRatingJsonOpenEvaluator}
              isLoading={deleteAssignedEvaluatorIdeaIsLoading}
              getJsonEvaluatorForRatingIsLoading={getJsonEvaluatorForRatingIsLoading}
              setDialogEvaluatorShowAllOpen={setDialogEvaluatorShowAllOpen}
              setDialogScoreCardShowAllOpen={setDialogScoreCardShowAllOpen}
              setDialogBusinessEvaluatorShowAllOpen={setDialogBusinessEvaluatorShowAllOpen}
              setDialogBusinessScoreCardShowAllOpen={setDialogBusinessScoreCardShowAllOpen}
              selectedEvaluator={selectedEvaluator}
              handleEvaluatorClick={handleEvaluatorClick}
              dialogEvaluatorOpen={dialogEvaluatorOpen}
              setDialogEvaluatorOpen={setDialogEvaluatorOpen}
            />
            }
          </div>
          

        </div>

        <Dialogs
          isHackathonChallenge={isHackathonChallengeFlag}
          isAdmin={isAdmin}
          isInnovator={isInnovator}
          isOrganizer={isOrganizer}
          isEvaluator={isEvaluator}
          ideaIdKey={getIdeaIdFromURL}
          challengeKey={challenge?.id}
          dialogOpen={dialogOpen}
          loginUserEmail={loginUserEmail}
          dialogOpenApprove={dialogOpenApprove}
          setDialogOpenApprove={setDialogOpenApprove}
          postInnovateIdeaApproveFn={postInnovateIdeaApproveFn}
          postApproveIdeaIsLoading={postApproveIdeaIsLoading}
          dialogEvaluatorOpen={dialogEvaluatorOpen}
          dialogEvaluatorRateOpen={dialogEvaluatorRateOpen}
          setDialogOpen={setDialogOpen}
          setDialogEvaluatorOpen={setDialogEvaluatorOpen}
          setDialogEvaluatorRateOpen={setDialogEvaluatorRateOpen}
          childValueSelectedUserTags={childValueSelectedUserTags}

          handleChildValueChange={setChildValueSelectedUserTags}
          onCommunityValueChange={setCommunityValueChange}
          communityValueChange={communityValueChange}
          handleConfirm={handleConfirm}
          handleCommunitySearchConfirm={handleCommunitySearchConfirm}
          evaluationLoading={evaluationLoading}
          userEvaluatorSuggestions={userEvaluatorSuggestions}
          searchByCommunityUserInnovateIdeaSuggestions={getSearchByCommunityUserInnovateIdeaSuggestions}
          onUserEvaluatorSearchSuggestions={onUserEvaluatorSearchSuggestions}
          onUserEvaluatorSearchByCommunitySuggestions={onUserEvaluatorSearchByCommunitySuggestions}
          formDataScorecardTemplate={scorecardTemplateJsonGetFromSourceTemplateID}
          // allRequerstParamsSendToAPI={addEvaluatorParamsObj}
          putInnovateIdeaEvaluatorRatingSubmitFn={putInnovateIdeaEvaluatorRatingSubmitFn}
          putInnovateIdeaEvaluatorRatingEditFn={putInnovateIdeaEvaluatorRatingEditFn}
          postInnovateIdeaEvaluatorRatingSaveFn={postInnovateIdeaEvaluatorRatingSaveFn}
          dialogEvaluatorShowAllOpen={dialogEvaluatorShowAllOpen}
          setDialogEvaluatorShowAllOpen={setDialogEvaluatorShowAllOpen}
          dialogScoreCardShowAllOpen={dialogScoreCardShowAllOpen}
          setDialogScoreCardShowAllOpen={setDialogScoreCardShowAllOpen}
          onHandleViewScorecard={handleScorecardRatingJsonOpenEvaluator}
          evaluators={getListEvaluatorAssignedIdea}
          onRemoveEvalutor={handleRemoveEvaluator}
          DeleteAssignedEvaluatorIdeaIsLoading={deleteAssignedEvaluatorIdeaIsLoading}
          getJsonEvaluatorForRatingIsLoading={getJsonEvaluatorForRatingIsLoading}
          getJsonEvaluatorForRating={getJsonEvaluatorForRating}
          selectedEvaluator={selectedEvaluator}
          handleEvaluatorClick={handleEvaluatorClick}
          setDialogOpenForTeamSearchAdd={setDialogOpenForTeamSearchAdd}
          dialogOpenForTeamSearchAdd={dialogOpenForTeamSearchAdd}
          handleAddTeamMemberConfirm={handleAddTeamMemberConfirm}
          onInviteTeamMemberFn={onInviteTeamMemberFn}
          postInnovateIdeaScorecardSaveRatingIsLoading={postInnovateIdeaScorecardSaveRatingIsLoading}

          dialogOpenBusinessScorecard={dialogOpenBusinessScorecard}
          setDialogOpenBusinessScorecard={setDialogOpenBusinessScorecard}
          listScorecardTemplateLoading={listScorecardTemplateLoading}
          listScorecardTemplate={listScorecardTemplate}
          putAddBusinessScoreCardFn={putAddBusinessScoreCardFn}
          innovateAddBusinessScoreCardIsLoading={innovateAddBusinessScoreCardIsLoading}
          ArrayOfObjDoubleScorecard={ArrayOfObjDoubleScorecard}
          ChallengeTemplateId={ChallengeTemplateId}
          businessScoreCardTemplateId={businessScoreCardTemplateId}
          handleChildValueOnChangeDBSC={setChildValue_Assign_Evaluator_Selected_SCData}
          innovateUserIsEvaluatorOrNot={checkEnableEvaluatorRatingButton}
          filteredDataGetListEvaluatorAssignedIdea={filteredDataGetListEvaluatorAssignedIdea}

          setDialogBusinessScoreCardShowAllOpen={setDialogBusinessScoreCardShowAllOpen}
          dialogBusinessScoreCardShowAllOpen={dialogBusinessScoreCardShowAllOpen}
          setDialogBusinessEvaluatorShowAllOpen={setDialogBusinessEvaluatorShowAllOpen}
          dialogBusinessEvaluatorShowAllOpen={dialogBusinessEvaluatorShowAllOpen}
          listCommunitesChallenge={listCommunitesChallenge}
          getShowPopupEvaluatorScorecardDataFn={getShowPopupForEvaluatorScorecardAssignedIdeaFn}
          getShowPopupEvaluatorScorecardDataResponse={innovateShowPopupEvaluatorAssignedData}
          showPopupScorecardIsLoading={innovateShowPopupEvaluatorAssignedDataIsLoading}
          isOwner={isOwnerRole}

        />

        <IdeaHistory
          open={dialogHistoryOpen}
          onClose={() => setDialogHistoryOpen(false)}
          historyData={ideaHistoryData}
          isLoading={ideaHistoryIsLoading}
        />
      </Container>
    </>
  );
};

export default withStyles(styles)(InnovateIdeaDetails);
